import styled from '@emotion/styled'

export const StyleReportRowWrapper = styled.div`
  display: flex;
  column-gap: 10px;
  flex-flow: row wrap;
  row-gap: 20px;
`

export const StyleReportItem = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 8px;
  position: relative;
  img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
  }
`

export const StyleReportItemRemoveWrapper = styled.div`
  width: 20px;
  height: 20px;
  background: ${(props: any) => props.theme.colors.danger};
  border-radius: 50%;
  display: flex;
  aling-items: center;
  justify-content: center;
  position: absolute;
  top: -5px;
  right: -10px;
`

export const StyleConsultWrapper = styled.ul`
  display: flex;
  flex-direction: column;
  row-gap: 10px;
`

export const StyleConsultItem = styled.li`
  list-style: disc;
  font-size: 18px;
  margin-left: 15px;
  color: ${(props: any) => props.theme.colors.secondary};
`
